import React, { useContext, useReducer, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { Collapse, Navbar } from 'reactstrap';
import { Global } from '../../App';
import LangSelector from '../GlobalSetting/LangSelector';
import ChangeFontSize from '../GlobalSetting/ChangeFontSize';
import cls from 'classnames';
import './Header.scss';
import '../../Resource/scss/icon.scss';
import logo_pc from '../../Resource/image/icons/img_logo_pc.png';
import logo_mobile from '../../Resource/image/icons/img_logo_mobile.png';
// api
import { postChangeOrderStatus } from '../../Api/staff/GetOrderInfo';
import { getLangOption } from '../../Api/GetLangOption';
import { useRef } from 'react';
import { useState } from 'react';
import { useMemo } from 'react';
import moment from 'moment';
import fp from 'lodash/fp'
import { useCallback } from 'react';

import { Portal } from 'react-portal'
import { Transition, TransitionGroup } from 'react-transition-group'
import icon from '../../Resource/image/icons/ic_menu_selected_new.png'
import { TimeOutRemove } from '../../Share/Tools/Share'

const NewHeader = ({ location, history, fontSize, onError }) => {
  const { globalState, dispatchGlobal } = useContext(Global)
  const [state, setState] = useState({
    isOpen: false,
    isFixed: false,
    isOpenLang: false,
    langOption: []
  })

  const userType = useMemo(() => {
    let pathname = location.pathname.replace(/<[^>]*>|/g, '');
    if (pathname.toLowerCase().indexOf('staff') > -1) {
      return 'staff';
    } else {
      return 'customer';
    }
  }, [location.pathname])

  const $toggleMenu = useCallback(() => {
    setState(fp.update('isOpen', state => !state))
  }, [])

  const $closeMenu = useCallback(() => {
    setState(fp.set('isOpen', false))
  }, [])

  useEffect(() => {
    async function apiLangOption() {
      try {
        let res = await getLangOption();
        const { errCode, language } = res.data;
        if (errCode === 200) {
          const newLangOption = language.map(e => ({
            title: e.original_name,
            langType: e.id
          }));
          setState(fp.set('langOption', newLangOption))

        } else {
          dispatchGlobal({
            type: 'UPDATE',
            payload: [{ key: 'errMsg', val: errCode }]
          });
          history.push('/error');
        }
      } catch (err) {
        console.error('LangOption error.');
        dispatchGlobal({
          type: 'UPDATE',
          payload: [{ key: 'errMsg', val: 403 }]
        });
        history.push('/error');
      }
    }

    apiLangOption()
  }, [dispatchGlobal, history])

  async function apiChangeOrderStatus(status) {
    try {
      let res
      try {
        res = await postChangeOrderStatus(status);
      } catch (err) {
        onError(4152)
        throw new Error()
      }
      if (res !== undefined) {
        let { errCode, save } = res.data;
        if (save && errCode === 200) {
          return true;
        } else {
          if (errCode === 999) {
            onError(errCode)
            throw new Error()
          } else {
            onError(errCode)
            throw new Error()
          }
        }
      }
    } catch (err) {
      throw new Error('error')
    }
  }

  const $logout = useCallback(async () => {
    const { prevPath, orderCode, checkOrderBranch, checkOrderData, takeOrderData } = globalState.staffInfo;
    if (prevPath === '/staffOrderDetail' || prevPath === '/staffTakeOrder'|| prevPath === '/staffCheckOrder') {
      const orderTime = (prevPath === '/staffOrderDetail'|| prevPath === '/staffCheckOrder')? checkOrderData.orderTime : takeOrderData.orderTime,
        orderStatus = {
          status: 1,
          orderCode,
          storeID: checkOrderBranch.branchCode,
          createAt: moment(orderTime).format('YYYY/MM/DD')
        };
      try {
        // 將訂單狀態改回未對單
        await apiChangeOrderStatus(orderStatus);
      } catch (err) {

      }
    }
    dispatchGlobal({ type: 'LOGOUT' });
  }, [dispatchGlobal, globalState.staffInfo])
  const $reset = useCallback(() => {
    if (userType === 'customer') {
      dispatchGlobal({ type: 'RESET' });
    } else {
      console.log('reset')
      dispatchGlobal({
        type: 'UPDATE',
        payload: [
          {
            key: 'staffInfo',
            val: {
              currentCheckOrderStep: '1',
              currentTakeOrderStep: '1',
              checkOrderBranch: globalState.staffInfo.checkOrderBranch,
              checkOrderGroup: globalState.staffInfo.checkOrderGroup,
              checkOrderStaff: globalState.staffInfo.checkOrderStaff,
              checkOrderData: null,
              takeOrderData: null
            }
          }
        ]
      });
    }
  }, [userType, dispatchGlobal, globalState.staffInfo])
  const $goToIndex = useCallback(() => {
    $reset()
    if (userType === 'customer') {
      history.push('/');
    } else {
      history.push('/staffCheckOrder');
      $logout()
    }
    $closeMenu()
  }, [userType, history, $closeMenu, $reset, $logout])

  const $renderedPopupMain = useMemo(() => {
    const menus = [
      { path: '/', type: 'customer', langId: 'header.menuItems.order', subPaths: ['/showOrderDetail', '/TakeOrderOnline'], className: 'menu-customer-order' },
      { path: '/showMenu', type: 'customer', langId: 'header.menuItems.menu', subPaths: [], className: 'menu-customer-menu' },
      { path: '/staffCheckOrder', type: 'staff', langId: 'header.menuItems.staffCheckOrder', subPaths: [], className: 'menu-staff-check' },
      { path: '/staffSearchOrder', type: 'staff', langId: 'header.menuItems.staffSearchOrder', subPaths: ['/staffOrderDetail'], className: 'menu-staff-search' },
      { path: '/staffTakeOrder', type: 'staff', langId: 'header.menuItems.staffTakeOrder', subPaths: [], className: 'menu-staff-order' },
      { path: '/staffMenu', type: 'staff', langId: 'header.menuItems.staffMenu', subPaths: ['/staffMenuDetail'], className: 'menu-staff-menu' },
      // { path: '/staffMenu', type: 'staff', langId: 'header.menuItems.StaffAddOrder', subPaths: [], className: 'menu-staff-menu' },
      { path: '/staffReminder', type: 'staff', langId: 'header.menuItems.CheckOrderReminder', subPaths: [], className: 'menu-staff-menu' }
    ]

    const {
      checkOrderBranch,
      checkOrderGroup,
      checkOrderStaff
    } = globalState.staffInfo;

    const isShowLogout = (
      userType === 'staff' &&
      checkOrderBranch &&
      checkOrderGroup &&
      checkOrderStaff
    )
    return (
      <div className={cls('NewHeaderMenu', globalState.langType)}>
        <div className='NewHeaderMenu__Items'>
          {menus.filter(item => item.type === userType).map((item, idx, arr) => {
            const activePaths = [item.path, ...item.subPaths].map(item => item.toLowerCase())
            const isActive = activePaths.includes(location.pathname.toLowerCase())
            return (
              <div
                key={idx}
                className={cls(['NewHeaderMenu__Items__Item ', { active: isActive }])}
                onClick={async () => {
                  TimeOutRemove();
                  const { prevPath, orderCode, checkOrderBranch, checkOrderData, takeOrderData } = globalState.staffInfo;
                  if (prevPath === '/staffOrderDetail' || prevPath === '/staffTakeOrder' ||  prevPath === '/staffCheckOrder'||  prevPath === '/staffCheckOrder') {
                    const orderTime = (prevPath === '/staffOrderDetail' || prevPath === '/staffCheckOrder') ? checkOrderData.orderTime : takeOrderData.orderTime,
                    orderStatus = {
                        status: 1,
                        orderCode,
                        storeID: checkOrderBranch.branchCode,
                        createAt: moment(orderTime).format('YYYY/MM/DD')
                      };
                    try {
                      // 將訂單狀態改回未對單
                      await apiChangeOrderStatus(orderStatus);
                    } catch (err) {

                    }
                  }
                  // 絕頂美味不reset
                  if (item.path !== '/showMenu') {
                    $reset()
                  }

                  $closeMenu()
                  // 絕頂美味導至官網
                  // if (item.path === '/showMenu') {
                  //   let langUrl = '';
                  //   switch (globalState.langType) {
                  //     case 'en':
                  //       langUrl = 'eng/';
                  //       break;
                  //     case 'ja':
                  //       langUrl = 'jp/';
                  //       break;
                  //     case 'ko':
                  //       langUrl = 'kr/';
                  //       break;
                  //   }
                  //   window.open(`https://www.dintaifung.com.tw/${langUrl}food.php`, '_blank')
                  // } else {
                  history.push(item.path)
                  // }
                }}
              >
                <img src={icon} alt='V' style={{ width: 31, height: 23, opacity: isActive ? 1 : 0 }} />
                <div className='NewHeaderMenu__Items__Item__LabelContainer'>
                  <div className={cls('NewHeaderMenu__Items__Item__Label', item.className)}>
                    <FormattedMessage id={item.langId} />
                  </div>
                </div>
              </div>
            )
          })}
        </div>
        <div className='d-block d-md-none'>
          <LangSelector
            mode="pc"
            options={state.langOption}
            onClose={() => {
              $closeMenu()
            }}
          />
        </div>
          <div className='d-block d-md-none'>
            <div className='d-flex align-items-center justify-content-center mt-3 mb-3'>
              <ChangeFontSize
                userType={userType}
                onClose={() => {
                  $closeMenu()
                }}
              />
            </div>
          </div>
       
        {isShowLogout && (
          <div className="d-flex align-items-center justify-content-center mt-3 mb-3">
            <a className="link" onClick={() => {
              $logout()
              $closeMenu()
              history.push('/staffCheckOrder');
            }}>
              <FormattedMessage id="header.staffLogOut" />
            </a>
          </div>
        )}
      </div>
    )
  }, [
    userType,
    location.pathname,
    $closeMenu,
    history,
    globalState.staffInfo,
    state.langOption,
    globalState.langType,
    $reset,
    $logout
  ])

  return (
    <>
      <div className='d-block d-md-none' style={{ height: 60 }} />
      <div className={cls(['NewHeader', { isOpen: state.isFixed }, { isOpenLang: state.isOpenLang }])}>
        <a
          style={{
            backgroundImage: `url(${logo_pc})`
          }}
          className={cls('NewHeader__Logo--PC d-none d-md-inline-block logo-pc', userType)}
          onClick={() => {
            TimeOutRemove();
            $goToIndex()
          }}
        />
        <div className='container p-0'>
          <div className='NewHeader__Bar'>
            <div className='NewHeader__Bar__Left'>
              <a
                style={{
                  backgroundImage: `url(${logo_mobile})`
                }}
                className={cls('NewHeader__Logo--Mobile d-inline-block d-md-none logo-mobile', userType)}
                onClick={() => {
                  TimeOutRemove();
                  $goToIndex()
                }}
              />
            </div>
            <div className='NewHeader__Bar__Right'>
              <div className='NewHeader__Bar__Right__Buttons'>
                <div className='d-none d-md-block'>
                  <LangSelector
                    mode="pc"
                    options={state.langOption}
                    onToggleLang={() => {
                      setState(fp.set('isOpenLang', !state.isOpenLang))
                    }}
                    onClose={() => {
                      $closeMenu()
                    }}
                  />
                </div>
                <a
                  className="icn icn_ic_menu__pc header__pc__menu_toggle"
                  onClick={$toggleMenu}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
      <Transition
        in={state.isOpen}
        appear
        timeout={150}
        onEntering={() => {
          setState(fp.set('isFixed', true))
        }}
        onExited={() => {
          setState(fp.set('isFixed', false))
        }}
      >
        {(state) => {
          if (state === 'exited') {
            return null
          }
          const className = `NewHeaderPopup ${state} ${fontSize}`
          return (
            <Portal>
              <div
                className={className}
                onClick={$toggleMenu}
              >
                <div
                  className='NewHeaderPopup__Main'
                  onClick={(e) => {
                    e.stopPropagation()
                  }}
                >
                  {$renderedPopupMain}
                </div>
              </div>
            </Portal>
          )
        }}
      </Transition>
    </>
  )
}

export default withRouter(NewHeader)

